import { Rule } from '../RuleBox'

const dutchAuctionRules: Array<Rule> = [
  {
    details:
      'In the case where a geotoken does not have any bids, it becomes a Dutch Auction, where the minimum deposit drops over time until a minter is found.',
    reason:
      'At times, a geotoken may have a minimum minting deposit that is prohibitive, especially if it is near a high value area. For example, the water geotoken near New York City would have a lower value than the geotoken right next to it.  The Dutch Auction allows the system to find the right minting deposit for the geotoken.',
    summary: 'Only occurs if auction failed to get a single bid',
  },
  {
    details: 'In a Dutch Auction, the geotoken can only be minted immediately.',
    reason: 'By not allowing a lower bid to be set, it forces the minter to decide to mint it or lose out on minting it.',
    summary: 'Current minimum minting stake is always the Mint Now price',
  },
  {
    details: 'Deposit drops approximately 3.3% per day, or 0.14% per hour, to a minimum of 0.02% of the original fee.',
    reason:
      'Promoting ownership of the geotokens is our number one priority. The price drop prevents geotokens from being unsold and overpriced for a long period of time.',
    summary: 'Minting deposit drops to minimum over approximately 30 days',
  },
]

export default dutchAuctionRules
